import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Footer } from '../components/Footer';
export function TermsPage() {
  return <div className="min-h-screen bg-[#F8FAFC] flex flex-col font-sans text-[#0F172A]" data-id="element-642">
      {/* Simple Header */}
      <header className="bg-white border-b border-slate-100 sticky top-0 z-50" data-id="element-643">
        <div className="container mx-auto px-6 max-w-6xl h-20 flex items-center justify-between" data-id="element-644">
          <Link to="/" className="flex items-center gap-2 font-heading text-xl font-bold text-[#0F172A] no-underline" data-id="element-645">
            <img src="https://assets.corkship.io/CorkShip%20Logo%20Original%20png.png" alt="CorkShip Logo" className="w-8 h-8 object-contain" data-id="element-646" />
            CorkShip
          </Link>
          <Link to="/" className="flex items-center gap-2 text-sm font-medium text-[#64748B] hover:text-[#0284C7] transition-colors" data-id="element-647">
            <ArrowLeft size={16} data-id="element-648" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow py-16 px-6" data-id="element-649">
        <article className="max-w-3xl mx-auto bg-white rounded-2xl shadow-sm border border-slate-100 p-8 md:p-12" data-id="element-650">
          {/* Page Header */}
          <header className="mb-12 text-center md:text-left border-b border-slate-100 pb-8" data-id="element-651">
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-[#0F172A] mb-4" data-id="element-652">
              Terms of Service
            </h1>
            <p className="text-[#64748B] text-lg" data-id="element-653">Last updated: January 2026</p>
          </header>

          {/* Content Body */}
          <div className="max-w-none" data-id="element-654">
            <section className="mb-12" data-id="element-655">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-656">
                1. Introduction
              </h2>
              <p className="text-[#0F172A] leading-[1.8] mb-6" data-id="element-657">
                Welcome to CorkShip. These Terms of Service ("Terms") govern
                your use of the CorkShip application ("App", "Service") provided
                by CorkShip ("we", "our", "us").
              </p>
              <p className="text-[#0F172A] leading-[1.8] mb-6" data-id="element-658">
                By installing or using CorkShip, you agree to these Terms. If
                you do not agree, please do not use the Service.
              </p>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-659" />

            <section className="mb-12" data-id="element-660">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-661">
                2. Description of Service
              </h2>
              <p className="text-[#0F172A] leading-[1.8] mb-4" data-id="element-662">
                CorkShip is an application that helps Australian wineries manage
                shipping fulfilment through Australia Post's eParcel service.
                The Service includes:
              </p>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-663">
                <li data-id="element-664">Smart parcel assignment based on bottle quantities</li>
                <li data-id="element-665">
                  Shipping label generation via Australia Post eParcel API
                </li>
                <li data-id="element-666">Manifest creation and management</li>
                <li data-id="element-667">Address and postcode validation</li>
                <li data-id="element-668">Order tracking synchronisation</li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-669" />

            <section className="mb-12" data-id="element-670">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-8" data-id="element-671">
                3. Eligibility
              </h2>
              <p className="text-[#0F172A] leading-[1.8] mb-4" data-id="element-672">
                To use CorkShip, you must:
              </p>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-673">
                <li data-id="element-674">Have an active Shopify or Commerce7 store</li>
                <li data-id="element-675">Have a valid Australia Post eParcel business account</li>
                <li data-id="element-676">Be located in or shipping from Australia</li>
                <li data-id="element-677">Be at least 18 years of age</li>
                <li data-id="element-678">Have the authority to bind your business to these Terms</li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-679" />

            <section className="mb-12" data-id="element-680">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-8" data-id="element-681">
                4. Account and Credentials
              </h2>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-682">
                Your Responsibilities
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-683">
                <li data-id="element-684">
                  You are responsible for maintaining the security of your store
                  and Australia Post credentials
                </li>
                <li data-id="element-685">
                  You must provide accurate Australia Post account information
                </li>
                <li data-id="element-686">
                  You must not share your account access with unauthorised
                  parties
                </li>
                <li data-id="element-687">
                  You are responsible for all activity that occurs through your
                  account
                </li>
              </ul>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-688">
                Our Responsibilities
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-689">
                <li data-id="element-690">
                  We encrypt and securely store your Australia Post credentials
                </li>
                <li data-id="element-691">
                  We do not access your credentials except to provide the
                  Service
                </li>
                <li data-id="element-692">We isolate your data from other users of the Service</li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-693" />

            <section className="mb-12" data-id="element-694">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-695">
                5. Acceptable Use
              </h2>
              <p className="text-[#0F172A] leading-[1.8] mb-4" data-id="element-696">
                You agree not to:
              </p>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-697">
                <li data-id="element-698">Use the Service for any unlawful purpose</li>
                <li data-id="element-699">Attempt to gain unauthorised access to our systems</li>
                <li data-id="element-700">Interfere with or disrupt the Service</li>
                <li data-id="element-701">Use the Service to ship prohibited items</li>
                <li data-id="element-702">
                  Reverse engineer or attempt to extract the source code of the
                  Service
                </li>
                <li data-id="element-703">
                  Resell or redistribute the Service without our permission
                </li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-704" />

            <section className="mb-12" data-id="element-705">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-8" data-id="element-706">
                6. Fees and Payment
              </h2>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-707">
                Subscription Fees
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-708">
                <li data-id="element-709">CorkShip is offered at $14.99 USD per month</li>
                <li data-id="element-710">
                  Fees are billed monthly through your platform's billing system
                </li>
                <li data-id="element-711">All fees are non-refundable except as required by law</li>
              </ul>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-712">
                Free Trial
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-713">
                <li data-id="element-714">New users receive a 14-day free trial</li>
                <li data-id="element-715">No credit card is required to start the trial</li>
                <li data-id="element-716">You will be notified before the trial ends</li>
              </ul>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-717">
                Price Changes
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-718">
                <li data-id="element-719">We may change our fees with 30 days notice</li>
                <li data-id="element-720">
                  Continued use after a price change constitutes acceptance
                </li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-721" />

            <section className="mb-12" data-id="element-722">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-8" data-id="element-723">
                7. Australia Post Integration
              </h2>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-724">
                Your Australia Post Account
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-725">
                <li data-id="element-726">
                  You must have your own Australia Post eParcel business account
                </li>
                <li data-id="element-727">
                  CorkShip connects to Australia Post using your credentials
                </li>
                <li data-id="element-728">
                  Australia Post's terms and conditions apply to all shipments
                </li>
                <li data-id="element-729">
                  Shipping rates are determined by Australia Post, not CorkShip
                </li>
              </ul>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-730">
                Service Limitations
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-731">
                <li data-id="element-732">CorkShip relies on Australia Post's API availability</li>
                <li data-id="element-733">
                  We are not responsible for Australia Post service outages or
                  delays
                </li>
                <li data-id="element-734">
                  Label generation requires a valid Australia Post connection
                </li>
                <li data-id="element-735">Tracking information is provided by Australia Post</li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-736" />

            <section className="mb-12" data-id="element-737">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-8" data-id="element-738">
                8. Shipping Responsibilities
              </h2>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-739">
                Your Responsibilities
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-740">
                <li data-id="element-741">Ensuring orders are packed correctly and safely</li>
                <li data-id="element-742">Verifying shipping addresses before generating labels</li>
                <li data-id="element-743">Complying with Australia Post's packaging requirements</li>
                <li data-id="element-744">
                  Complying with wine shipping regulations (including age
                  verification)
                </li>
                <li data-id="element-745">Handing parcels to Australia Post for delivery</li>
              </ul>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-746">
                Our Responsibilities
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-747">
                <li data-id="element-748">
                  Generating accurate shipping labels based on information you
                  provide
                </li>
                <li data-id="element-749">Syncing tracking numbers back to your store</li>
                <li data-id="element-750">Providing tools to manage your shipping workflow</li>
              </ul>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-751">
                What We Don't Control
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-752">
                <li data-id="element-753">
                  Actual delivery of parcels (this is Australia Post's
                  responsibility)
                </li>
                <li data-id="element-754">Delivery timeframes</li>
                <li data-id="element-755">
                  Lost or damaged parcels (claims must be made with Australia
                  Post)
                </li>
                <li data-id="element-756">Australia Post service disruptions</li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-757" />

            <section className="mb-12" data-id="element-758">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-759">
                9. Intellectual Property
              </h2>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-760">
                <li data-id="element-761">
                  CorkShip and its original content, features, and functionality
                  are owned by us
                </li>
                <li data-id="element-762">
                  The CorkShip name, logo, and branding are our trademarks
                </li>
                <li data-id="element-763">You may not copy, modify, or distribute our software</li>
                <li data-id="element-764">
                  Your data remains yours — we claim no ownership of your order
                  or customer data
                </li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-765" />

            <section className="mb-12" data-id="element-766">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-767">
                10. Privacy
              </h2>
              <p className="text-[#0F172A] leading-[1.8]" data-id="element-768">
                Your privacy is important to us. Please review our{' '}
                <Link to="/privacy" className="text-[#0284C7] hover:underline" data-id="element-769">
                  Privacy Policy
                </Link>{' '}
                which explains how we collect, use, and protect your
                information.
              </p>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-770" />

            <section className="mb-12" data-id="element-771">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-8" data-id="element-772">
                11. Service Availability
              </h2>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-773">
                Uptime
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-774">
                <li data-id="element-775">
                  We strive to maintain high availability but do not guarantee
                  100% uptime
                </li>
                <li data-id="element-776">
                  We may perform maintenance that temporarily affects
                  availability
                </li>
                <li data-id="element-777">
                  We will try to notify you of planned maintenance in advance
                </li>
              </ul>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-778">
                Changes to the Service
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-779">
                <li data-id="element-780">
                  We may modify or discontinue features with reasonable notice
                </li>
                <li data-id="element-781">We may release updates and new features at any time</li>
                <li data-id="element-782">
                  Significant changes will be communicated via email or in-app
                  notification
                </li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-783" />

            <section className="mb-12" data-id="element-784">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-785">
                12. Limitation of Liability
              </h2>
              <p className="text-[#0F172A] leading-[1.8] mb-4" data-id="element-786">
                To the maximum extent permitted by law:
              </p>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-787">
                <li data-id="element-788">
                  CorkShip is provided "as is" without warranties of any kind
                </li>
                <li data-id="element-789">
                  We are not liable for any indirect, incidental, or
                  consequential damages
                </li>
                <li data-id="element-790">
                  Our total liability is limited to the fees you paid in the 12
                  months prior to the claim
                </li>
                <li data-id="element-791">
                  We are not liable for issues caused by Australia Post, your
                  platform, or your own actions
                </li>
              </ul>
              <p className="text-[#0F172A] leading-[1.8]" data-id="element-792">
                This does not affect any rights you have under Australian
                Consumer Law that cannot be excluded.
              </p>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-793" />

            <section className="mb-12" data-id="element-794">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-795">
                13. Indemnification
              </h2>
              <p className="text-[#0F172A] leading-[1.8] mb-4" data-id="element-796">
                You agree to indemnify and hold us harmless from any claims,
                damages, or expenses arising from:
              </p>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-797">
                <li data-id="element-798">Your use of the Service</li>
                <li data-id="element-799">Your violation of these Terms</li>
                <li data-id="element-800">Your violation of any third-party rights</li>
                <li data-id="element-801">Any dispute between you and your customers</li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-802" />

            <section className="mb-12" data-id="element-803">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-8" data-id="element-804">
                14. Termination
              </h2>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-805">
                By You
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-806">
                <li data-id="element-807">
                  You may stop using CorkShip at any time by uninstalling the
                  app from your store
                </li>
                <li data-id="element-808">No refunds are provided for partial billing periods</li>
              </ul>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-809">
                By Us
              </h3>
              <p className="text-[#0F172A] leading-[1.8] mb-4" data-id="element-810">
                We may suspend or terminate your access if:
              </p>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-811">
                <li data-id="element-812">You violate these Terms</li>
                <li data-id="element-813">You fail to pay fees when due</li>
                <li data-id="element-814">Your use poses a security risk</li>
                <li data-id="element-815">Required by law</li>
              </ul>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-816">
                Effect of Termination
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-817">
                <li data-id="element-818">Your data will be deleted within 30 days of termination</li>
                <li data-id="element-819">You may request a data export before uninstalling</li>
                <li data-id="element-820">Any outstanding fees remain payable</li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-821" />

            <section className="mb-12" data-id="element-822">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-8" data-id="element-823">
                15. Dispute Resolution
              </h2>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-824">
                Governing Law
              </h3>
              <p className="text-[#0F172A] leading-[1.8] mb-6" data-id="element-825">
                These Terms are governed by the laws of Victoria, Australia.
              </p>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-826">
                Resolution Process
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-827">
                <li data-id="element-828">
                  Contact us first at{' '}
                  <a href="mailto:support@corkship.com.au" className="text-[#0284C7] hover:underline" data-id="element-829">
                    support@corkship.com.au
                  </a>{' '}
                  to resolve any issues
                </li>
                <li data-id="element-830">
                  If we cannot resolve the dispute informally, either party may
                  pursue legal remedies
                </li>
                <li data-id="element-831">
                  Any legal proceedings shall be conducted in the courts of
                  Victoria, Australia
                </li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-832" />

            <section className="mb-12" data-id="element-833">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-8" data-id="element-834">
                16. General Provisions
              </h2>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-835">
                Entire Agreement
              </h3>
              <p className="text-[#0F172A] leading-[1.8] mb-6" data-id="element-836">
                These Terms, together with our Privacy Policy, constitute the
                entire agreement between you and CorkShip.
              </p>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-837">
                Severability
              </h3>
              <p className="text-[#0F172A] leading-[1.8] mb-6" data-id="element-838">
                If any provision of these Terms is found unenforceable, the
                remaining provisions remain in effect.
              </p>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-839">
                No Waiver
              </h3>
              <p className="text-[#0F172A] leading-[1.8] mb-6" data-id="element-840">
                Our failure to enforce any right or provision does not
                constitute a waiver.
              </p>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-841">
                Assignment
              </h3>
              <p className="text-[#0F172A] leading-[1.8]" data-id="element-842">
                You may not assign your rights under these Terms. We may assign
                our rights to a successor or acquirer.
              </p>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-843" />

            <section className="mb-12" data-id="element-844">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-845">
                17. Changes to These Terms
              </h2>
              <p className="text-[#0F172A] leading-[1.8] mb-4" data-id="element-846">
                We may update these Terms from time to time. We will notify you
                of material changes by:
              </p>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-847">
                <li data-id="element-848">Posting a notice in the app</li>
                <li data-id="element-849">Sending an email to your store email</li>
                <li data-id="element-850">Updating the "Last updated" date</li>
              </ul>
              <p className="text-[#0F172A] leading-[1.8]" data-id="element-851">
                Continued use after changes constitutes acceptance of the new
                Terms.
              </p>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-852" />

            <section className="mb-12" data-id="element-853">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-854">
                18. Contact Us
              </h2>
              <p className="text-[#0F172A] leading-[1.8] mb-4" data-id="element-855">
                If you have questions about these Terms:
              </p>
              <ul className="list-none space-y-2 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-856">
                <li data-id="element-857">
                  <strong data-id="element-858">Email:</strong>{' '}
                  <a href="mailto:support@corkship.com.au" className="text-[#0284C7] hover:underline" data-id="element-859">
                    support@corkship.com.au
                  </a>
                </li>
                <li data-id="element-860">
                  <strong data-id="element-861">Address:</strong> CorkShip Melbourne, Victoria
                  Australia
                </li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-862" />

            <section data-id="element-863">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-864">
                Summary
              </h2>
              <div className="overflow-x-auto" data-id="element-865">
                <table className="w-full text-left border-collapse mt-6" data-id="element-866">
                  <thead data-id="element-867">
                    <tr className="bg-slate-50 border-b border-slate-200" data-id="element-868">
                      <th className="p-4 font-bold text-[#0F172A]" data-id="element-869">Topic</th>
                      <th className="p-4 font-bold text-[#0F172A]" data-id="element-870">
                        Key Points
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-sm" data-id="element-871">
                    <tr className="border-b border-slate-100" data-id="element-872">
                      <td className="p-4" data-id="element-873">What you get</td>
                      <td className="p-4" data-id="element-874">
                        Shipping label generation, parcel assignment, manifest
                        management
                      </td>
                    </tr>
                    <tr className="border-b border-slate-100" data-id="element-875">
                      <td className="p-4" data-id="element-876">What you need</td>
                      <td className="p-4" data-id="element-877">
                        Shopify or Commerce7 store + Australia Post eParcel
                        account
                      </td>
                    </tr>
                    <tr className="border-b border-slate-100" data-id="element-878">
                      <td className="p-4" data-id="element-879">Cost</td>
                      <td className="p-4" data-id="element-880">
                        $14.99 USD/month after 14-day free trial
                      </td>
                    </tr>
                    <tr className="border-b border-slate-100" data-id="element-881">
                      <td className="p-4" data-id="element-882">Your data</td>
                      <td className="p-4" data-id="element-883">
                        Remains yours, deleted within 30 days of uninstall
                      </td>
                    </tr>
                    <tr className="border-b border-slate-100" data-id="element-884">
                      <td className="p-4" data-id="element-885">Australia Post</td>
                      <td className="p-4" data-id="element-886">
                        Their terms apply to actual shipping; we just generate
                        labels
                      </td>
                    </tr>
                    <tr className="border-b border-slate-100" data-id="element-887">
                      <td className="p-4" data-id="element-888">Liability</td>
                      <td className="p-4" data-id="element-889">
                        Limited to fees paid; we don't control delivery
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </div>
        </article>
      </main>

      {/* Footer */}
      <Footer data-id="element-890" />
    </div>;
}